import axios from 'axios';

const apiCIP = axios.create({
    baseURL: process.env.REACT_APP_CIP_API_URL,
    //  baseURL: 'http://192.168.18.11:8080/',
});

apiCIP.interceptors.request.use((config) => {
    const token = localStorage.getItem("accessToken") || process.env.REACT_APP_CIP_API_URL;
    config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export default apiCIP;
